import { XEO_AUTHORIZATION_HEADER } from './constants';

interface CredentialsStore {
  [key: string]: string;
}

function getCredentialsStorageValue(): CredentialsStore {
  const storage = localStorage.getItem(XEO_AUTHORIZATION_HEADER);
  const credentials: CredentialsStore = storage ? JSON.parse(storage) : {};
  return credentials;
}

export function getProjectCredentials(projectId: string): string | null {
  const credentials = getCredentialsStorageValue();
  return credentials[projectId] || null;
}

export function setProjectCredentials(projectId: string, credentials: string): void {
  const storage = getCredentialsStorageValue();
  storage[projectId] = credentials;
  localStorage.setItem(XEO_AUTHORIZATION_HEADER, JSON.stringify(storage));
}

export function removeProjectCredentials(projectId: string): void {
  const storage = getCredentialsStorageValue();
  delete storage[projectId];
  localStorage.setItem(XEO_AUTHORIZATION_HEADER, JSON.stringify(storage));
}
